// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__3DGQi","modal":"Modal_modal__12XnZ","slide-down":"Modal_slide-down__2KmY-"};